import sentry from '~/utils/sentry'

const { captureException } = sentry()

const captureError = (err, ctx, user) => {
  captureException(err, ctx, user)
}

export default captureError
